import { GridApi } from '@ag-grid-community/core';
import { CommonModule, NgClass } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
} from '@angular/core';
import { FormsModule } from '@angular/forms';
import { NgSelectModule } from '@ng-select/ng-select';

@Component({
  changeDetection: ChangeDetectionStrategy.Default,
  imports: [NgSelectModule, NgClass, CommonModule, FormsModule],
  selector: 'aux-pagination-panel',
  templateUrl: './pagination-panel.component.html',
})
export class PaginationPanelComponent implements OnInit {
  @Input() gridApi?: GridApi;
  pageSize = 10;
  @Output() paginationChange = new EventEmitter<void>();
  @Input() paginationPageSize?: number;
  @Input() totalItems?: number;

  ngOnInit() {
    if (
      this.paginationPageSize &&
      Number.isInteger(this.paginationPageSize) &&
      this.paginationPageSize > 0
    ) {
      this.pageSize = this.paginationPageSize;
    }
  }

  getCurrentPage = () => (this.gridApi?.paginationGetCurrentPage() || 0) + 1;

  getFirstRowOnPageNumber = () => {
    return this.gridApi
      ? this.gridApi.paginationGetPageSize() * this.gridApi.paginationGetCurrentPage() + 1
      : 0;
  };

  getLastRowOnPageNumber = () => {
    if (this.gridApi) {
      return this.gridApi.paginationGetCurrentPage() + 1 === this.gridApi.paginationGetTotalPages()
        ? this.gridApi.paginationGetRowCount()
        : this.gridApi.paginationGetPageSize() * (this.gridApi.paginationGetCurrentPage() + 1);
    }

    return 0;
  };

  getRowCount = () => this.totalItems || this.gridApi?.paginationGetRowCount();

  getTotalPages = () =>
    this.totalItems
      ? Math.ceil(this.totalItems / this.pageSize)
      : this.gridApi?.paginationGetTotalPages();

  isFirstPage = () => this.gridApi?.paginationGetCurrentPage() === 0;

  isLastPage = () => {
    this.updateServerSideRowCount();

    return this.gridApi
      ? this.gridApi.paginationGetCurrentPage() + 1 === this.getTotalPages()
      : true;
  };

  paginateToLastPage() {
    this.gridApi?.paginationGoToLastPage();
    this.paginationChange.emit();
  }

  paginateToNextPage() {
    this.gridApi?.paginationGoToNextPage();
    this.paginationChange.emit();
  }

  paginationGoToFirstPage() {
    this.gridApi?.paginationGoToFirstPage();
    this.paginationChange.emit();
  }

  paginationGoToPreviousPage() {
    this.gridApi?.paginationGoToPreviousPage();
    this.paginationChange.emit();
  }

  paginationSizeChange(event: number) {
    this.gridApi?.setGridOption('paginationPageSize', event);
    this.paginationChange.emit();
  }

  private updateServerSideRowCount() {
    if (this.totalItems) {
      this.gridApi?.setRowCount(this.totalItems, false);
    }
  }
}
